var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoadingTrainingOutfits ? _c("Loader") : _vm._e(),
      _vm._v(" "),
      !_vm.isLoadingTrainingOutfits
        ? _c(
            "div",
            [
              _c("p", { staticClass: "cta" }, [
                _vm._v("Keep swiping! We're learning your style...")
              ]),
              _vm._v(" "),
              _c("Logo", { staticClass: "logo" }),
              _vm._v(" "),
              _vm.outfitCurrent
                ? _c("OutfitSwipe", {
                    attrs: {
                      outfitCurrent: _vm.outfitCurrent,
                      noOutfitsForTheseFilters: false,
                      visitProduct: false,
                      saveOutfit: _vm.saveOutfit,
                      rejectOutfit: _vm.rejectOutfit
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce23e148", { render: render, staticRenderFns: staticRenderFns })
  }
}